module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods",
    style: (_vm.bannerFlag ? 'margin-top: 45px;' : '')
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "w"
  }, [_vm._l((_vm.category), function(val, i) {
    return _c('a', {
      class: {
        active: _vm.sortType === i
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.clickSort(i, val)
        }
      }
    }, [_vm._v(_vm._s(val))])
  }), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "请输入商品信息",
      "prefix-icon": "el-icon-search"
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "text": "搜索",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.loadMallGoods
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "container w"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "55vh"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [(_vm.goodsList.length > 0) ? _c('div', {
    staticClass: "goods-item w"
  }, [_c('div', {
    staticClass: "goods-box"
  }, _vm._l((_vm.goodsList), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      },
      on: {
        "openDialog": _vm.openDialog
      }
    })
  }), 1), _vm._v(" "), (_vm.goodsList.length > 0 && !_vm.error) ? _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [8, 16, 20],
      "page-size": _vm.params.pageSize,
      "total": _vm.total,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.noGoods) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('y-shelf', {
    attrs: {
      "title": _vm.recommendPanel.name
    }
  }, [_c('div', {
    staticClass: "recommend",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.recommendPanel.panelContents), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('y-shelf', {
    attrs: {
      "title": _vm.recommendPanel.name
    }
  }, [_c('div', {
    staticClass: "recommend",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.recommendPanel.panelContents), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1)]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogFlag,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFlag = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/qr/qrcode.jpg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫码进入"), _c('span', {
    staticStyle: {
      "color": "#007aff"
    }
  }, [_vm._v("医小智Mall")]), _vm._v("小程序下单")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-search.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！暂时还没有商品\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b445736a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mall/index.vue
// module id = 687
// module chunks = 0